// Localized editorial section slugs (per language). /i18n is excluded from the FR i18n guardrail.
import { SUPPORTED } from "@/i18n/translations";

export const SECTION_KEYS = ["news", "advice", "stories"];

export const SECTION_SLUGS = {
  news: { fr: "actualites", en: "news", es: "actualidad", it: "attualita", de: "agrar-news", nl: "nieuws", sv: "nyheter", da: "nyheder", bg: "novini", el: "nea", hr: "vijesti", et: "uudised", fi: "uutiset", hu: "hirek", lv: "zinas", lt: "naujienos", pl: "aktualnosci", pt: "atualidade", ro: "actualitate", sk: "aktuality", sl: "novice", cs: "aktuality" },
  advice: { fr: "conseils", en: "tips", es: "consejos", it: "consigli", de: "ratgeber", nl: "tips", sv: "tips", da: "raad", bg: "saveti", el: "symvoules", hr: "savjeti", et: "nouanded", fi: "vinkit", hu: "tanacsok", lv: "padomi", lt: "patarimai", pl: "porady", pt: "dicas", ro: "sfaturi", sk: "rady", sl: "nasveti", cs: "rady" },
  stories: { fr: "histoires-de-fermes", en: "farm-stories", es: "historias-de-granjas", it: "storie-di-fattorie", de: "hofgeschichten", nl: "boerderijverhalen", sv: "gardsberattelser", da: "gaardhistorier", bg: "istorii-na-fermi", el: "istories-farmas", hr: "price-s-farmi", et: "talulood", fi: "tilatarinat", hu: "farmtortenetek", lv: "fermu-stasti", lt: "ukiu-istorijos", pl: "historie-gospodarstw", pt: "historias-de-quintas", ro: "povesti-de-ferma", sk: "pribehy-fariem", sl: "zgodbe-kmetij", cs: "pribehy-farem" },
};

export const sectionSlug = (lang, key) => (SECTION_SLUGS[key] || {})[lang] || (SECTION_SLUGS[key] || {}).fr || key;

// Reciprocal hreflang set for a section hub across all languages (+ x-default).
export const sectionAlternates = (key, siteUrl) => {
  const map = SECTION_SLUGS[key] || {};
  const langs = (SUPPORTED || Object.keys(map));
  const alts = langs.filter((l) => map[l]).map((l) => ({
    hreflang: l,
    href: `${siteUrl}${l === "fr" ? "" : `/${l}`}/${map[l]}`,
  }));
  alts.push({ hreflang: "x-default", href: `${siteUrl}/${map.fr}` });
  return alts;
};
